module.exports = __webpack_public_path__ + "img/1-C-resources-bg.83945866.png";